import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DeclineCategoryRow } from '../interfaces/decline-reason-mapping.interface';
import { DeclineMappingGridContext, DeclineMappingGridHostApi } from '../interfaces/decline-mapping-grid-host.interface';

@Component({
  selector: 'decline-mapping-portal-cell',
  templateUrl: './decline-mapping-portal-cell.component.html',
  styleUrls: ['./decline-mapping-cell-renderers.styles.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeclineMappingPortalCellComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>;
  portalId = '';

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): void {
    this.params = params;
    this.portalId = (params.colDef?.cellRendererParams as { portalId?: string })?.portalId ?? '';
  }

  refresh(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): boolean {
    this.params = params;
    this.portalId = (params.colDef?.cellRendererParams as { portalId?: string })?.portalId ?? '';
    this.cdr.markForCheck();
    return true;
  }

  get host(): DeclineMappingGridHostApi | undefined {
    return this.params?.context?.host;
  }

  get row(): DeclineCategoryRow | undefined {
    return this.params?.data;
  }

  get reasons(): string[] {
    if (!this.row || !this.portalId) {
      return [];
    }
    return this.row.mappings[this.portalId] ?? [];
  }

  get visibleReasons(): string[] {
    return this.reasons.slice(0, 3);
  }

  get hiddenCount(): number {
    return Math.max(0, this.reasons.length - 3);
  }

  get active(): boolean {
    return !!(this.row && this.host?.isCellActive(this.row.id, this.portalId));
  }

  get hasItems(): boolean {
    return !this.active && this.reasons.length > 0;
  }

  onCellClick(): void {
    if (!this.row || !this.host) {
      return;
    }
    this.host.clickCell(this.row.id, this.portalId);
  }

  onRemove(reason: string, ev: MouseEvent): void {
    ev.stopPropagation();
    if (!this.row || !this.host) {
      return;
    }
    this.host.removeReason(this.row, this.portalId, reason);
  }

  onKeyActivate(ev: KeyboardEvent): void {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.onCellClick();
    }
  }
}
